(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var settings = theme.settings || {};

  /* ——— Utilities ——— */
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, theme.moneyFormat || '${{amount}}');
    }
    return (cents / 100).toFixed(2);
  }

  function fetchConfig(type) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
  }

  /* ——— Mobile nav drawer ——— */
  function initNavDrawer() {
    var toggle = document.getElementById('menu-toggle');
    var drawer = document.getElementById('site-nav-drawer');
    if (!toggle || !drawer) return;

    var closeEls = drawer.querySelectorAll('[data-close-drawer]');

    function setDrawer(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('drawer-open', open);
    }

    toggle.addEventListener('click', function () {
      setDrawer(!drawer.classList.contains('is-open'));
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        setDrawer(false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });
  }

  /* ——— Cart drawer ——— */
  var Cart = {
    drawer: null,
    content: null,

    init: function () {
      this.drawer = document.getElementById('cart-drawer');
      this.content = document.getElementById('cart-drawer-content');
      if (!this.drawer) return;

      var self = this;

      document.querySelectorAll('[data-open-cart]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          if (settings.cartDrawer) {
            e.preventDefault();
            self.open();
          }
        });
      });

      this.drawer.querySelectorAll('[data-close-cart]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.close();
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });

      this.content.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-remove-line]');
        var qtyBtn = e.target.closest('[data-qty-change]');
        if (removeBtn) {
          e.preventDefault();
          self.changeLine(removeBtn.getAttribute('data-remove-line'), 0);
        }
        if (qtyBtn) {
          e.preventDefault();
          var key = qtyBtn.getAttribute('data-qty-change');
          var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
          self.changeLine(key, qty);
        }
      });
    },

    open: function () {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      this.refresh();
    },

    close: function () {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    },

    refresh: function () {
      var self = this;
      var sectionUrl = routes.cart_url + '?section_id=cart-drawer';

      return fetch(sectionUrl)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner =
            doc.querySelector('#shopify-section-cart-drawer-inner') ||
            doc.querySelector('#shopify-section-cart-drawer');
          if (inner && self.content) {
            self.content.innerHTML = inner.innerHTML;
          }
          return self.updateCartCount();
        })
        .catch(function (err) {
          console.error('Cart refresh failed', err);
        });
    },

    updateCartCount: function () {
      return fetch(routes.cart_url + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          var drawerCount = document.getElementById('cart-drawer-count');
          if (drawerCount) drawerCount.textContent = cart.item_count;
          return cart;
        });
    },

    add: function (formData) {
      var self = this;
      return fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw data;
            return data;
          });
        })
        .then(function () {
          if (settings.cartDrawer) {
            self.open();
          } else {
            window.location.href = routes.cart_url;
          }
          return self.refresh();
        });
    },

    changeLine: function (key, quantity) {
      var self = this;
      return fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          return self.refresh();
        });
    },
  };

  /* ——— Product form + variants ——— */
  var SWATCH_COLORS = {
    black: '#1a1a1a',
    white: '#ffffff',
    red: '#c0392b',
    blue: '#2980b9',
    green: '#27ae60',
    yellow: '#f1c40f',
    orange: '#e67e22',
    pink: '#e91e8c',
    purple: '#8e44ad',
    gray: '#95a5a6',
    grey: '#95a5a6',
    navy: '#2c3e50',
    brown: '#795548',
    beige: '#d7ccc8',
    silver: '#bdc3c7',
    gold: '#d4af37',
  };

  function applySwatchColors() {
    document.querySelectorAll('[data-swatch-name]').forEach(function (el) {
      var name = el.getAttribute('data-swatch-name');
      if (name && SWATCH_COLORS[name]) {
        el.style.backgroundColor = SWATCH_COLORS[name];
      } else {
        el.style.backgroundColor = '#e5e5e5';
      }
    });
  }

  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var productJsonEl = form.closest('.product-page')?.querySelector('[data-product-json]');
      if (!productJsonEl) {
        productJsonEl = document.querySelector('[data-product-json]');
      }
      var product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
      var variantInput = form.querySelector('[data-variant-id]');
      var priceEl = form.querySelector('[data-price]');
      var compareEl = form.querySelector('[data-compare-price]');
      var addBtn = form.querySelector('[data-add-to-cart]');
      var addText = form.querySelector('[data-add-to-cart-text]');
      var mainImage = document.querySelector('[data-main-image]');
      var messageEl = form.querySelector('[data-form-message]');

      function getSelectedOptions() {
        var options = [];
        form.querySelectorAll('[data-option-input]:checked').forEach(function (input) {
          options.push(input.value);
        });
        form.querySelectorAll('select[data-option-input]').forEach(function (select) {
          options.push(select.value);
        });
        return options;
      }

      function findVariant() {
        if (!product) return null;
        var selected = getSelectedOptions();
        return product.variants.find(function (v) {
          var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
          return opts.every(function (opt, i) {
            return opt === selected[i];
          });
        });
      }

      function updateVariantUI() {
        var variant = findVariant();
        if (!variant) return;

        if (variantInput) variantInput.value = variant.id;

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (addBtn) addBtn.disabled = !variant.available;
        if (addText) {
          addText.textContent = variant.available
            ? theme.strings?.addToCart || 'Add to cart'
            : theme.strings?.soldOut || 'Sold out';
        }

        if (mainImage && variant.featured_image) {
          mainImage.src = variant.featured_image.src;
          mainImage.alt = variant.featured_image.alt || product.title;
        }

        form.querySelectorAll('[data-option-input]').forEach(function (input) {
          var label = input.closest('label');
          if (label) label.classList.toggle('is-selected', input.checked);
        });
      }

      form.querySelectorAll('[data-option-input]').forEach(function (input) {
        input.addEventListener('change', updateVariantUI);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        if (messageEl) messageEl.hidden = true;

        Cart.add(formData)
          .then(function () {
            if (messageEl) {
              messageEl.textContent = theme.strings?.addedToCart || 'Added to cart';
              messageEl.hidden = false;
            }
          })
          .catch(function (err) {
            if (messageEl) {
              messageEl.textContent = err.description || err.message || 'Could not add to cart';
              messageEl.hidden = false;
            }
          });
      });

      updateVariantUI();
    });

    applySwatchColors();
  }

  /* ——— Scroll reveal animations ——— */
  function initRevealAnimations() {
    if (settings.animations === false) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var stagger = 100;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10) * stagger;
          setTimeout(function () {
            el.classList.add('is-visible');
          }, delay);
          observer.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      observer.observe(el);
    });

    /* Animate above-the-fold elements on load */
    requestAnimationFrame(function () {
      document.querySelectorAll('.section--hero [data-reveal], .announcement-bar').forEach(function (el, i) {
        setTimeout(function () {
          el.classList.add('is-visible');
        }, 80 + i * 80);
      });
    });
  }

  /* ——— Header height sync (logo-driven) ——— */
  function syncHeaderHeight() {
    var header = document.getElementById('site-header');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  function initHeaderHeight() {
    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);

    var logo = document.querySelector('.site-header__logo');
    if (logo) {
      if (logo.complete) {
        syncHeaderHeight();
      } else {
        logo.addEventListener('load', syncHeaderHeight);
      }
    }

    if (typeof ResizeObserver !== 'undefined') {
      var header = document.getElementById('site-header');
      if (header) {
        new ResizeObserver(syncHeaderHeight).observe(header);
      }
    }
  }

  /* ——— Boot ——— */
  function initCookiePreferences() {
    var btn = document.querySelector('[data-cookie-preferences]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.showConsentBanner();
        return;
      }
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '1.0' }],
          function () {
            if (window.Shopify.customerPrivacy) {
              window.Shopify.customerPrivacy.showConsentBanner();
            }
          }
        );
      }
    });
  }

  /* ——— Collection grid: staggered fade-in on load ——— */
  function initCollectionProductReveal() {
    var items = document.querySelectorAll('[data-collection-reveal]');
    if (!items.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || settings.animations === false) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var stagger = 70;
    items.forEach(function (el, i) {
      setTimeout(function () {
        el.classList.add('is-visible');
      }, 60 + i * stagger);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNavDrawer();
    Cart.init();
    initProductForms();
    initRevealAnimations();
    initCollectionProductReveal();
    initCookiePreferences();
    initHeaderHeight();
  });
})();
